import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'
import { HttpMethod } from '../../../services/core'

const resource = 'templates'
const verb = HttpMethod.DELETE

export default class OspreyTemplatesRemoveFromAffiliationsShare extends BaseAction {
    constructor(dataKey) {
        const id = '493c949a-bad9-4dae-842e-dddb40c29e42'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    removeFromAffiliationsShare(params) {
        const { templateId, affiliationIdList } = params

        this.path = `/${resource}/${templateId}/share/affiliations`

        this.params = {
            affiliationIdList
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/templates/templates-affiliations-remove.js